import Reflux from 'reflux';

import actions from '../actions';
import configurationStore from './configuration-store';

import baseStateStore from './base-state-store';

export default Reflux.createStore(
	Object.assign({}, baseStateStore, {
		init() {
			this.listenToMany(actions);
			this.listenTo(configurationStore, this.onConfigurationChange);
			this.state = {
				itemListPage: -1,
				lastSelectedFacetId: undefined,
				lastClickedFacetId: undefined,
				userSelection: {},
				userSelections: {},
				preselectionHash: '',
				configuration: {
					preselection: {},
					defaultUserSelection: {},
					automaticUserSelection: {}
				}
			};
		},

		_saveUserSelection(hash) {
			this.state.userSelections[hash] = this.state.userSelection;
		},

		_restoreSavedUserSelection(hash) {
			if (this.state.userSelections[hash]) {
				Object.assign(this.state.userSelection, this.state.userSelections[hash]);
			}
		},

		onConfigurationChange(configuration) {
			this.state.configuration = {
				preselection: configuration.accessories.preselection,
				defaultUserSelection: configuration.accessories.defaultUserSelection,
				automaticUserSelection: configuration.accessories.automaticUserSelection
			};
		},

		loadAccessorySheet() {
			this.state.itemListPage = 0;
			this.output();

			actions.loadAccessory();
		},

		onNextAccessoryListPage() {
			this.state.itemListPage++;
			this.output();

			actions.loadAccessories();
		},

		onResetAccessoryListPage() {
			this.state.itemListPage = -1;
			this.output();

			actions.loadAccessories();
		},

		onLoadAccessoriesCompleted() {
			actions.loadAccessoriesDone();
		},

		onInitializeWizards() {
			this.state.userSelection = Object.assign({}, this.state.configuration.preselection,
				this.state.configuration.defaultUserSelection);
			Object.keys(this.state.userSelection).forEach((facetId) => {
				this._applyAutomaticUserSelection(this.state.userSelection[facetId]);
			});
			this.output();
		},

		onSelectAccessoryProperties(properties) {
			this.state.userSelection = properties;
			Object.keys(properties).forEach((facetId) => {
				this._applyAutomaticUserSelection(properties[facetId]);
			});

			const isItemListActivated = this.state.itemListPage > -1;
			this.state.itemListPage = isItemListActivated ? 0 : -1;
			this.output();

			actions.loadAccessoryFacets();
			actions.loadAccessoryCount();
			if (isItemListActivated) {
				actions.loadAccessories();
			}
		},

		_getPreselectionHash() {
			return Object.keys(this.state.configuration.preselection)
				.map(facetId => this.state.userSelection[facetId])
				.join(',');
		},

		onSelectAccessoryProperty(facet, property) {
			if (property.countUnselected === 0 && !facet.isPreselecting) {
				return;
			}

			// get current state
			const currentPropertyId = this.state.userSelection[facet.id];
			const newPropertyId = currentPropertyId !== property.id ? property.id : null;

			if (newPropertyId === null && !property.isDeselectable) {
				return;
			}

			// reset selection?
			if (facet.isPreselecting) {
				this._applyDefaultUserSelection();
			}

			// reset other facets?
			this._applyResetting(facet.resettingOtherFacetIds);

			// make selection
			this._applyUserSelection(facet.id, newPropertyId);

			// automatic user selection
			this._applyAutomaticUserSelection(property.id);

			// save user selection
			const preselectionHash = this._getPreselectionHash();

			if (facet.isPreselecting) {
				this._restoreSavedUserSelection(preselectionHash);
			} else {
				this._saveUserSelection(preselectionHash);
			}

			// last facet for scrolling etc.
			this.state.lastClickedFacetId = facet.id;
			const isItemListActivated = this.state.itemListPage > -1;
			this.state.itemListPage = isItemListActivated ? 0 : -1;
			this.output();

			actions.loadAccessoryFacets();
			actions.loadAccessoryCount({autoSheet: true});
			if (isItemListActivated) {
				actions.loadAccessories();
			}
		}
	})
);
